module.exports = __webpack_public_path__ + "static/wc_text-c4739ae76c5467048a36d2994adb3e7d.png";